import { ConfirmPrompt } from './ConfirmPrompt';

export type DiscardPendingPromptProps = {
    title: string;
    count: number;
    confirmLabel: string;
    onConfirm: () => void;
    onCancel: () => void;
};

// Asks before dropping pending log entries that were never applied.
export const DiscardPendingPrompt: React.FC<DiscardPendingPromptProps> = ({ title, count, confirmLabel, onConfirm, onCancel }) => (
    <ConfirmPrompt
        title={title}
        body={`${count} pending ${count === 1 ? 'entry' : 'entries'} will be discarded. This can't be undone.`}
        confirmLabel={confirmLabel}
        destructive
        onConfirm={onConfirm}
        onCancel={onCancel}
    />
);
